import { type IWidgetComponentProps } from '@framework/engine/schema/widgets/IWidgetType.ts';
import { CommonComputedWidgetConfigComponent } from '@framework/engine/schema/widgets/repository/computed/CommonComputedWidgetConfigComponent.tsx';
import { useTreeReferencesGlobalContext } from '@framework/engine/tree/references/TreeReferencesGlobalContext.tsx';
import { CheckboxInput } from '@framework/form/inputs/CheckboxInput.tsx';
import { FormItem } from '@framework/form/item/FormItem.tsx';
import { MacroBurdenTypeSelectInput } from '../../../schema/macro-burden-types/BurdenTypeSelectInput.tsx';
import { type IBurdenWidget } from './IBurdenWidget.ts';

export interface IBurdenWidgetConfigComponentProps
  extends IWidgetComponentProps<IBurdenWidget> {}

export function BurdenWidgetConfigComponent(
  props: IBurdenWidgetConfigComponentProps,
) {
  const globalContext = useTreeReferencesGlobalContext();
  const profiloAgid = globalContext?.metadata?.profiloAgid;
  // Se il profiloAgid è configurato e diverso da 'NESSUNO',
  // consideriamo isAgid come true, altrimenti undefined
  // (per non includere il parametro nella query)
  const isAgid =
    (profiloAgid != null && profiloAgid !== 'NESSUNO') || undefined;

  return (
    <div>
      <FormItem
        name="macroBurdenTypeId"
        label={'Macro tipo di onere'}
        help={
          'Indica il macro tipo di onere da utilizzare. Il tipo onere deve essere configurato a livello di singolo ufficio e verrà selezionato automaticamente dal sistema in base alla Competenza selezionata dal richiedente.'
        }
      >
        <MacroBurdenTypeSelectInput
          name="macroBurdenTypeId"
          objectName="macroBurdenType"
          isAgid={isAgid}
        />
      </FormItem>
      <FormItem
        name="showVisualAsterisk"
        label={null}
        layout={{ removeLabelSpace: true }}
        help={
          "Se selezionato, verrà mostrato un asterisco accanto all'etichetta del widget. L'asterisco è solo un'indicazione visiva e non influisce sulla validazione del campo."
        }
      >
        <CheckboxInput name="showVisualAsterisk" defaultChecked={false}>
          Mostra asterisco obbligatorietà
        </CheckboxInput>
      </FormItem>
      <CommonComputedWidgetConfigComponent
        {...props}
        expressionLabel="Importo"
      />
    </div>
  );
}
